import {cn} from '@/lib/utils'
import {UserRoundIcon} from 'lucide-react'

export function PhotoPlaceholder({className, ...props}: React.ComponentProps<'div'>) {
  return (
    <div data-slot='skeleton' className={cn('flex place-content-center place-items-center rounded-md bg-muted', className)} {...props}>
      <UserRoundIcon className='text-muted-foreground opacity-10' size={80} />
    </div>
  )
}
